import { render, staticRenderFns } from "./ProjectApprovalSettingComponent.vue?vue&type=template&id=274ef454&scoped=true&"
import script from "./ProjectApprovalSettingComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectApprovalSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectApprovalSettingComponent.vue?vue&type=style&index=0&id=274ef454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ef454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VMain,VRow})
